import type { ModuleId } from '@mentimeter/http-clients';

export const DEPRECATED_MODULE_IDS: ModuleId[] = [
  'heading',
  'paragraph',
  'bullets',
  'number',
  'quote',
  'big',
];

export const EDITOR_MOBILE_OVERVIEW_CONTAINER_HEIGHT = 105;
